export default "__VITE_ASSET__D11mSK4___"